import './Home.css';

const Home = ()=> {
  return (
    <div id="home-unit">
      <div id ="hello">
        <h2 id="first-line">Hi, my name is </h2>
        <h1 id="name">Luwam!</h1>
      </div>
      <div id="parag">
        <p> I am an enthusiastic full-stack software engineer. I am knowledgable in several areas including Restful API's, HTML/CSS, Python, Flask, JavaScript, React.js, SQLAlchemy, PostgreSQL, GitHub, Git, Bootstrap, Tailwind CSS, Version Control System, Unit Testing, Debugging, Render, Heroku, Object-Oriented Programming (OOP), and Algorithms. I’m a life long learner committed to crafting websites that not only elevate user experiences but also have a profound impact on our daily routines.</p>
      </div>
    </div>
  );
}
export default Home;